var today = new Date(); //  timezone
document.getElementById("next-shipment").innerHTML=FormatDate(GetNextDay(today));

function GetNextDay(date) {
  date.setDate(date.getDate() + 1); // move to next day.
  switch (date.getDay()) {
    case 0: //Sunday
    case 6: //Saturday
      date = GetNextDay(date);
  }
  return date;
}

function FormatDate(date) {
  var months = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER"
  ];

  return (
    months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear()
  );
}